/** Local-time end of the Halloween season (exclusive). */
export const SEASON_END = new Date('2026-11-03T00:00:00')

export function isSeasonOpen(now: Date = new Date()): boolean {
  return now.getTime() < SEASON_END.getTime()
}
